// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusProg25Icon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-9z" />
  </svg>,
  "StatusProg25",
);
export default StatusProg25Icon;
